"use client";
import React from "react";

import Hero from "@/sections/HeroSection";
import SmoothScroll from "@/sections/horizontalScroll";
import HavaDurumu from "@/sections/hava";
import Moon from "@/sections/moon";
import Sunshine from "@/sections/sunshine";
import Zoadiac from "@/sections/zodiac";
import Planets from "@/sections/planets";
import NoteComponent from "@/sections/note";
import Stars1 from "@/sections/map1";
import Blur from "@/components/overlay/Blur";
import Color from "@/components/overlay/Color";
import NavBar from "@/sections/NavBar";
import About from "@/sections/About";
import Footer from "@/sections/Footer";
import Heroerror from '../../../sections/Herorror';


export default function Page({ params }: { params: { id: string } }) {
    
    const code = params.id;

    const [valid, setValid] = React.useState(false);
const [load , setLoad] = React.useState(false);

  React.useEffect(() => {
      
      async function getData() {
        
          const valid = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/findorder?certificate=${code}`);
          const valid2 = await valid.json();
          // if valid2.orderid is not null, then it is valid. else throw error
            if (valid2.orderid == null) {

                setValid(false);
                setLoad(true);
            }else {
                setValid(true);
                setLoad(true);
            }
         
      }
      getData();
  }
  , [])
  

    return (
        <><Blur />
        <Color />
        <NavBar /> 
        
        {load &&(  <main
                className="flex flex-col items-center justify-center bg-black"
            >
        {valid ? (

<>

            {/*<ScrollerMotion // Weird, stuff happening with this
                disabled={isMobile}
                spring={{ mass: 1, stiffness:800, bounce: 300, damping: 100 }}
            >*/}
         
                <Hero certificate={code} />
                <NoteComponent certificate={code} />
                <About certificate={code} />

                <HavaDurumu certificate={code} />
                <Moon certificate={code} />
                <Sunshine certificate={code} />
                
{/*                 <Work />
 */}                <Zoadiac certificate={code} />
                <Planets certificate={code} />
                <SmoothScroll certificate={code} />
{/*                 <Tools />
 */}                                <Stars1 certificate={code} />
           
            {/*</ScrollerMotion>*/}</>
        )
        :
        (
            <Heroerror certificate={1} />
        )
        }<Footer />

           </main>)}
        </>
    );
}
